module.exports = __webpack_public_path__ + "img/flowchart.63976cde.png";